import { useConsent } from '../../lib/consent-context';

// Footer entry point for consent WITHDRAWAL / change. GDPR Art. 7(3) requires
// withdrawing consent to be as easy as giving it — this link is always present
// and re-opens the Preference Center. Styled to match the adjacent footer
// legal links (renders as a button for correct keyboard semantics).

export function CookieSettingsLink() {
  const { openPreferences } = useConsent();
  return (
    <button type="button" className="cookie-settings-link" onClick={openPreferences}>
      Cookie preferences
    </button>
  );
}
